import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { useScrollDeep } from "@/hooks/useScrollDeep";

export default function CustomiseScopeFAB() {
  const deep = useScrollDeep(0.45);
  const navigate = useNavigate();

  return (
    <button
      type="button"
      data-testid="customise-scope-fab"
      onClick={() => navigate("/customise-scope")}
      aria-label="Customise your scope"
      className="group fixed bottom-6 left-1/2 z-50 inline-flex items-center gap-2.5 rounded-full px-6 py-3.5 transition-all duration-500 ease-out hover:-translate-y-1"
      style={{
        opacity: deep ? 1 : 0,
        pointerEvents: deep ? "auto" : "none",
        transform: `translateX(-50%) ${deep ? "translateY(0)" : "translateY(16px)"}`,
        background: "rgba(255, 255, 255, 0.15)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        border: "1px solid rgba(255, 255, 255, 0.25)",
        boxShadow:
          "0 8px 30px rgba(39, 112, 253, 0.18), 0 2px 8px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.4)",
      }}
    >
      <Sparkles className="h-4 w-4 text-[#2770FD]" />
      <span
        className="slow-flicker text-sm sm:text-base font-bold tracking-tight"
        style={{ color: "#2770FD" }}
      >
        Customise Your Scope
      </span>
      <ArrowRight className="h-4 w-4 text-[#2770FD] transition-transform group-hover:translate-x-1" />
    </button>
  );
}
